import { render, staticRenderFns } from "./ta_project_details2.vue?vue&type=template&id=7ef797ec&scoped=true&"
import script from "./ta_project_details2.vue?vue&type=script&lang=js&"
export * from "./ta_project_details2.vue?vue&type=script&lang=js&"
import style0 from "./ta_project_details2.vue?vue&type=style&index=0&id=7ef797ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef797ec",
  null
  
)

export default component.exports